import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "korax_coach_complete_v4";

const steps = [
  {
    id: "conversations-center",
    chapter: "Primeiros passos",
    title: "Sua operação começa aqui",
    description:
      "Parabéns! Sua Korax está pronta. Todas as novas conversas da sua empresa chegam nesta central."
  },
  {
    id: "conversations-ai-tab",
    chapter: "Central de Conversas",
    title: "Atendimentos com a Korax IA",
    description:
      "Nesta aba ficam as conversas atendidas automaticamente pela Korax IA. Ela responde, qualifica e conduz cada cliente."
  },
  {
    id: "ticket-ai-control",
    chapter: "Atendimento humano",
    title: "Assumir uma conversa",
    description:
      "Abra uma conversa atendida pela IA e clique aqui quando quiser pausar a Korax e continuar o atendimento pessoalmente."
  },
  {
    id: "ticket-ai-control",
    chapter: "Atendimento inteligente",
    title: "Retomar a Korax IA",
    description:
      "Quando terminar sua participação, clique aqui para devolver a conversa. A Korax IA continuará o atendimento de onde você parou."
  },
  {
    id: "ticket-korax-powers",
    chapter: "Superpoderes da Korax",
    title: "Ações inteligentes",
    description:
      "Neste botão você acessa os superpoderes da conversa: Modo Missão, sequências, oportunidades, assistente Korax, etiquetas e detalhes do lead."
  },
  {
    id: "menu-conversations",
    chapter: "Operação Comercial",
    title: "Central de Conversas",
    description:
      "Acompanhe todos os atendimentos da sua empresa em um único lugar, com organização e histórico completo."
  },
  {
    id: "menu-kanban",
    chapter: "Operação Comercial",
    title: "Kanban",
    description:
      "Visualize cada cliente no estágio correto da negociação e acompanhe o avanço das oportunidades."
  },
  {
    id: "menu-sales",
    chapter: "Operação Comercial",
    title: "Vendas",
    description:
      "Centralize suas oportunidades comerciais, valores, responsáveis e previsões de fechamento."
  },
  {
    id: "menu-contacts",
    chapter: "Operação Comercial",
    title: "Contatos",
    description:
      "Consulte e organize os dados de todos os clientes e leads atendidos pela sua empresa."
  },
  {
    id: "menu-follow-up",
    chapter: "Operação Comercial",
    title: "Follow-up",
    description:
      "Programe retornos para não esquecer clientes interessados e evitar oportunidades perdidas."
  },
  {
    id: "menu-sequences",
    chapter: "Operação Comercial",
    title: "Sequências",
    description:
      "Crie cadências de mensagens para enviar aos seus clientes com apenas um clique."
  },
  {
    id: "menu-agenda",
    chapter: "Operação Comercial",
    title: "Agenda",
    description:
      "Organize reuniões e compromissos. Tanto sua equipe quanto a Korax IA podem realizar os agendamentos."
  },
  {
    id: "menu-catalog",
    chapter: "Operação Comercial",
    title: "Catálogo",
    description:
      "Cadastre seus produtos e serviços para que a Korax IA possa apresentá-los aos clientes. Você também recebe um link do catálogo para compartilhar."
  },
  {
    id: "menu-tags",
    chapter: "Operação Comercial",
    title: "Etiquetas",
    description:
      "Classifique contatos e conversas para criar uma operação mais organizada e segmentada."
  },
  {
    id: "menu-getting-started",
    chapter: "Administração",
    title: "Comece por aqui",
    description:
      "Revise sua configuração inicial sempre que precisar ajustar os primeiros passos da operação."
  },
  {
    id: "menu-ai-credits",
    chapter: "Administração",
    title: "Créditos IA",
    description:
      "Acompanhe o consumo dos recursos de inteligência artificial disponíveis na sua conta."
  },
  {
    id: "menu-ai-library",
    chapter: "Administração",
    title: "Biblioteca Korax IA",
    description:
      "Adicione materiais, informações e documentos que ajudam a Korax a conhecer melhor sua empresa."
  },
  {
    id: "menu-campaigns",
    chapter: "Administração",
    title: "Campanhas",
    description:
      "Crie comunicações em escala para divulgar novidades, ofertas e conteúdos aos seus contatos."
  },
  
  {
    id: "menu-team",
    chapter: "Administração",
    title: "Equipe",
    description:
      "Cadastre usuários, organize permissões e defina quem participa da operação."
  },
  {
    id: "menu-sectors",
    chapter: "Administração",
    title: "Setores",
    description:
      "Distribua os atendimentos entre áreas e responsáveis de acordo com a necessidade do cliente."
  },
  {
    id: "menu-korax-ai",
    chapter: "Plataforma",
    title: "Korax IA",
    description:
      "Aqui fica o cérebro da sua operação: configure, treine e evolua o comportamento da inteligência artificial."
  },
  {
    id: "menu-integrations",
    chapter: "Plataforma",
    title: "Integrações",
    description:
      "Conecte a Korax a outras ferramentas e amplie as possibilidades da sua operação."
  },
  {
    id: "menu-whatsapp",
    chapter: "Plataforma",
    title: "WhatsApp",
    description:
      "Gerencie as conexões utilizadas no atendimento e acompanhe o status dos seus números."
  },
  {
    id: "menu-files",
    chapter: "Plataforma",
    title: "Arquivos",
    description:
      "Organize materiais que podem ser utilizados pela equipe durante os atendimentos."
  },
  {
    id: "menu-financial",
    chapter: "Plataforma",
    title: "Assinatura",
    description:
      "Acompanhe as informações da assinatura relacionadas ao uso da plataforma."
  }
];

const KoraxGuide = () => {
  const location = useLocation();
  const [active, setActive] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [targetRect, setTargetRect] = useState(null);

  const currentStep = steps[stepIndex];

  useEffect(() => {
    const isOnboarding = location.pathname.startsWith("/onboarding");
    const isConversationArea =
      location.pathname === "/tickets" ||
      location.pathname.startsWith("/tickets/");

    setActive(
      !isOnboarding &&
      isConversationArea &&
      localStorage.getItem(STORAGE_KEY) !== "completed"
    );
  }, [location.pathname]);

  useEffect(() => {
    if (!active || !currentStep || window.innerWidth >= 960) return;

    window.dispatchEvent(
      new CustomEvent("koraxGuideDrawer", {
        detail: { open: currentStep.id.startsWith("menu-") }
      })
    );
  }, [active, currentStep]);

  useEffect(() => {
    if (!active || !currentStep) {
      setTargetRect(null);
      return undefined;
    }

    let missingAttempts = 0;
    let element = null;

    const updateTarget = () => {
      element = document.querySelector(`[data-guide="${currentStep.id}"]`);

      if (!element) {
        missingAttempts += 1;
        setTargetRect(null);

        if (missingAttempts >= 5) {
          setStepIndex(index =>
            index >= steps.length - 1 ? index : index + 1
          );
        }

        return;
      }

      missingAttempts = 0;

      const rect = element.getBoundingClientRect();

      if (
        rect.top < 12 ||
        rect.bottom > window.innerHeight - 12
      ) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }

      setTargetRect({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        right: rect.right,
        bottom: rect.bottom
      });
    };

    const initialTimer = window.setTimeout(updateTarget, 150);
    const interval = window.setInterval(updateTarget, 400);

    window.addEventListener("resize", updateTarget);
    window.addEventListener("scroll", updateTarget, true);

    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
      window.removeEventListener("resize", updateTarget);
      window.removeEventListener("scroll", updateTarget, true);
    };
  }, [active, currentStep]);

  const finish = () => {
    localStorage.setItem(STORAGE_KEY, "completed");
    setActive(false);
  };

  const next = () => {
    if (stepIndex >= steps.length - 1) {
      finish();
      return;
    }

    setStepIndex(index => index + 1);
  };

  const previous = () => {
    setStepIndex(index => Math.max(0, index - 1));
  };

  if (
    window.innerWidth < 960 ||
    location.pathname.startsWith("/onboarding") ||
    !active ||
    !currentStep ||
    !targetRect
  ) {
    return null;
  }

  const bubbleWidth = 360;
  const spaceOnRight = window.innerWidth - targetRect.right;
  const placeOnRight = spaceOnRight >= bubbleWidth + 40;

  const bubbleLeft = placeOnRight
    ? Math.min(
        targetRect.right + 18,
        window.innerWidth - bubbleWidth - 16
      )
    : Math.max(16, targetRect.left - bubbleWidth - 18);

  const bubbleTop = Math.min(
    Math.max(16, targetRect.top),
    window.innerHeight - 290
  );

  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 2147483000,
          background: "rgba(2, 6, 23, 0.58)",
          pointerEvents: "none"
        }}
      />

      <div
        style={{
          position: "fixed",
          zIndex: 2147483001,
          top: targetRect.top - 6,
          left: targetRect.left - 6,
          width: targetRect.width + 12,
          height: targetRect.height + 12,
          borderRadius: 12,
          border: "2px solid #3B82F6",
          boxShadow:
            "0 0 0 9999px rgba(2, 6, 23, 0.58), 0 0 0 5px rgba(59,130,246,0.22), 0 18px 50px rgba(15,23,42,0.35)",
          pointerEvents: "none",
          transition: "all 0.2s ease"
        }}
      />

      <div
        style={{
          position: "fixed",
          zIndex: 2147483002,
          top: bubbleTop,
          left: bubbleLeft,
          width: bubbleWidth,
          maxWidth: "calc(100vw - 32px)",
          padding: 20,
          borderRadius: 18,
          background:
            "linear-gradient(145deg, #FFFFFF 0%, #F8FAFC 100%)",
          border: "1px solid rgba(148,163,184,0.25)",
          boxShadow: "0 24px 70px rgba(15,23,42,0.28)",
          color: "#0F172A"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 12
          }}
        >
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 11,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "linear-gradient(135deg, #155EEF 0%, #153EAD 100%)",
              color: "#FFFFFF",
              fontSize: 19,
              boxShadow: "0 8px 18px rgba(21,94,239,0.25)"
            }}
          >
            ✦
          </div>

          <div>
            <div
              style={{
                fontSize: 10,
                fontWeight: 800,
                letterSpacing: "0.09em",
                textTransform: "uppercase",
                color: "#155EEF"
              }}
            >
              {currentStep.chapter}
            </div>

            <div
              style={{
                marginTop: 3,
                fontSize: 17,
                fontWeight: 800,
                lineHeight: 1.2
              }}
            >
              {currentStep.title}
            </div>
          </div>
        </div>

        <div
          style={{
            fontSize: 14,
            lineHeight: 1.55,
            color: "#475569"
          }}
        >
          {currentStep.description}
        </div>

        <div
          style={{
            height: 4,
            marginTop: 18,
            overflow: "hidden",
            borderRadius: 999,
            background: "#E2E8F0"
          }}
        >
          <div
            style={{
              width: `${((stepIndex + 1) / steps.length) * 100}%`,
              height: "100%",
              borderRadius: 999,
              background:
                "linear-gradient(90deg, #155EEF 0%, #38BDF8 100%)",
              transition: "width 0.25s ease"
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            marginTop: 15
          }}
        >
          <button
            type="button"
            onClick={finish}
            style={{
              border: 0,
              background: "transparent",
              padding: 6,
              color: "#64748B",
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer"
            }}
          >
            Pular apresentação
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                marginRight: 4,
                fontSize: 11,
                fontWeight: 700,
                color: "#94A3B8"
              }}
            >
              {stepIndex + 1}/{steps.length}
            </span>

            <button
              type="button"
              onClick={previous}
              disabled={stepIndex === 0}
              style={{
                minHeight: 34,
                padding: "0 12px",
                borderRadius: 9,
                border: "1px solid #CBD5E1",
                background: "#FFFFFF",
                color: stepIndex === 0 ? "#CBD5E1" : "#334155",
                fontSize: 12,
                fontWeight: 800,
                cursor: stepIndex === 0 ? "default" : "pointer"
              }}
            >
              Voltar
            </button>

            <button
              type="button"
              onClick={next}
              style={{
                minHeight: 34,
                padding: "0 14px",
                borderRadius: 9,
                border: 0,
                background:
                  "linear-gradient(135deg, #155EEF 0%, #153EAD 100%)",
                color: "#FFFFFF",
                fontSize: 12,
                fontWeight: 800,
                cursor: "pointer",
                boxShadow: "0 8px 16px rgba(21,94,239,0.22)"
              }}
            >
              {stepIndex === steps.length - 1
                ? "Começar a usar"
                : "Próximo"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default KoraxGuide;
